<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M15 11.6665L18.3333 14.9998L15 18.3332"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15 1.6665L18.3333 4.99984L15 8.33317"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M1.66667 15.0001H3.31084C3.84958 15.0038 4.38119 14.8768 4.86013 14.6301C5.33907 14.3833 5.75107 14.0242 6.06084 13.5834L10.6058 6.41674C10.9156 5.97595 11.3276 5.61681 11.8065 5.37008C12.2855 5.12336 12.8171 4.9964 13.3558 5.00008H18.3333"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M1.66667 5.00008H3.31001C3.93122 4.99576 4.54128 5.16512 5.07137 5.48906C5.60145 5.813 6.03047 6.27863 6.31001 6.83341"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M18.3333 15H13.2992C12.753 14.9944 12.2165 14.8547 11.737 14.5932C11.2575 14.3316 10.8496 13.9562 10.5492 13.5L10.25 13.125"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconShuffle',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
